import React from 'react'
import withHOCs from 'util/withHocs'
import EditIcon from '@material-ui/icons/Edit'
import {
  filter,
  findIndex,
  isEmpty,
  isEqual,
  isNull,
  isUndefined,
} from 'lodash'
import { Create } from '@material-ui/icons'
import {
  SwipeableDrawer,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import { GetApp } from '@material-ui/icons'
import { CSVLink } from 'react-csv'
import DownloadIcon from '@mui/icons-material/Download'
import BottomBar from 'components/BottomBar'
import {
  downloadAOGCSV,
  editItemsFlyoutToggle,
  fetchAutoOrderGridSample,
  fetchAutoOrderGridSampleSubClass,
  getSizes,
  openAutoOrder,
  showPopup,
  closePopup,
  setCheckBox,
  setCheckBoxHeaderChange,
  unsetSelectedData,
  setAutoOrderSamplesSuccess,
} from '../../store/autoOrderSamples/actionCreator'
import {
  getAutoOrderGridColumn,
  getAutoOrderSamples,
  getCsvCompleteAutoOrderSamples,
  getCsvHeaders,
} from '../../store/autoOrderSamples/selectors'
import {
  getAllBrands,
  getAllDepartments,
  editFlyOut,
  editSubmit,
  getClassByMultiDepartment,
} from '../../store/autoOrderFilters/actionCreator'
import apiConfig from 'apiConfig'
import {
  getAllBrandOptions,
  getAllDepartmentsOptions,
  getFilterOptionsByFilter,
} from '../../store/autoOrderFilters/selectors'
import { Link } from 'react-router-dom'
import { Grid, Button } from '@material-ui/core'
import CustomTabs from '../../components/Tabs/Tabs'
import FlexibleTable from '../../components/EnhancedTable/FlexibleTable'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CheckBoxAutoComplete from './CheckBoxAutoComplete' //need to convert into component
import { setHeaderTitleArray } from '../../store/layout/actionCreator'
import EditAutoOrderSamplesFlyout from './EditAutoOrderSamplesFlyout'
import { RenderSelectionFields, aogTabLabels } from './EditAutoOrderConstants'
import TabbedPopUp from 'components/PopUp/TabbedPopUp'
import { makeTabTables } from 'util/Table'
import ShowIf from 'components/ShowIf'
import ItemEditCard from 'components/EditCard/ItemEditCard'
import { normalizeSizeValues } from 'util/CommonUtils'
const styles = (theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(3),
  },
  autoOrderDownload: {
    marginLeft: '78%',
    position: 'absolute',
    marginTop: '75px',
  },
  autoOrderDownloadButton: {
    textDecoration: 'none',
    color: '#366CD9',
  },
  autoOrderEdit: {
    marginLeft: '87%',
    position: 'absolute',
    marginTop: '75px',
  },
  autoOrderNotAuthorizedEdit: {
    marginLeft: '78%',
    position: 'absolute',
    marginTop: '75px',
  },
  defaultButton: {
    width: 'auto',
    margin: '0px 8px',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '1.2rem',
  },
  downloadButton: {
    marginLeft: '64.5%',
    position: 'absolute',
    marginTop: '75px',
  },
  swipeableDrawerElementsContainer: {
    overflow: 'hidden',
    backgroundColor: '#366cd9',
    height: '50px',
  },
})
export class AutoOrderingGrid extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      aogFilters: {},
      aogSubclassFilters: {},
      currentTabValue: 'aog',
    }
  }
  componentDidMount() {
    const {
      getAllBrands = () => {},
      getAllDepartments = () => {},
      setHeaderTitleArray = () => {},
      getSizes = () => {},
    } = this.props
    setHeaderTitleArray([{ title: 'Auto Ordering Settings' }])
    getAllDepartments()
    getSizes()
    this.refreshAutoOrderGrid()
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      aogSubclassFilters: prevAogSubclassFilters = {},
      aogFilters: prevAogFilters = {},
      currentTabValue: prevCurrentTabValue = '',
    } = prevState
    const {
      aogSubclassFilters = {},
      aogFilters = {},
      currentTabValue = '',
    } = this.state

    if (
      (Object.entries(aogSubclassFilters)?.length > 0 &&
        !isEqual(aogSubclassFilters, prevAogSubclassFilters)) ||
      (Object.entries(aogFilters)?.length > 0 &&
        !isEqual(aogFilters, prevAogFilters)) ||
      (currentTabValue && prevCurrentTabValue !== currentTabValue)
    ) {
      this.filterAutoOrderGrid()
    }
    if (
      aogFilters['Department'] &&
      !isNull(aogFilters['Department']) &&
      prevAogFilters['Department'] !== aogFilters['Department']
    ) {
      const deptIds = aogFilters['Department'].map((item) => item.id)
      this.props.getClassByMultiDepartment(deptIds)
    }
  }
  componentWillUnmount() {
    const { openAutoOrder = () => {} } = this.props
    openAutoOrder('')
  }
  onEditClick = () => {
    const { editItemsFlyoutToggle = () => {} } = this.props
    editItemsFlyoutToggle()
  }

  filterAutoOrderGrid = () => {
    const {
      fetchAutoOrderGridSample = () => {},
      fetchAutoOrderGridSampleSubClass = () => {},
      autoOrderSamples = {},
      setAutoOrderSamplesSuccess = {},
    } = this.props
    const {
      currentTabValue = '',
      aogSubclassFilters = {},
      aogFilters = {},
    } = this.state
    const curFilters =
      currentTabValue === 'aog' ? aogFilters : aogSubclassFilters

    let updatedFilters = {}
    const filterTypeKeys = {
      Department: 'departmentId',
      Brands: 'brandId',
      Class: 'classId',
    }
    Object.keys(curFilters).map((filterType = '') => {
      const currentFilter = curFilters[filterType] || []
      const curFilterSelValues = currentFilter.map((obj) =>
        filterType === 'Class' ? Number(obj.id.split('-')[1]) : obj.id
      )
      updatedFilters[filterTypeKeys[filterType] || filterType] = {}
      updatedFilters[filterTypeKeys[filterType] || filterType][
        'requestParamValue'
      ] = curFilterSelValues
      return filterType
    })

    currentTabValue === 'aogsubclass'
      ? fetchAutoOrderGridSampleSubClass(updatedFilters)
      : Object.keys(updatedFilters).forEach((key) => {
          const filterValue = updatedFilters[key]?.requestParamValue || []
          if (filterValue.length > 0) {
            setAutoOrderSamplesSuccess(autoOrderSamples, updatedFilters)
          } else {
            fetchAutoOrderGridSample(updatedFilters)
          }
        })
  }
  renderBottomBar = () => {
    const { classes = {}, numSelected = Number(0) } = this.props
    return (
      <BottomBar
        anchor="bottom"
        variant={'persistent'}
        open={this.toggleOpen()}
        onOpen={() => null}
        onClose={() => null}
        showClearAll={numSelected > 0}
        actionType={'REST_ALL_AUTO_ORDER_GRID_SAMPLES'}
      >
        <div className={classes.swipeableDrawerElementsContainer}>
          <Button
            id="copyToClipboard"
            data-id="Copy To Clipboard"
            className={classes.defaultButton}
            startIcon={<EditIcon />}
            onClick={() => this.onEditClick()}
          >
            Edit Record(s)
          </Button>
        </div>
      </BottomBar>
    )
  }

  toggleOpen = () => {
    const { numSelected, auth = {} } = this.props
    const {
      roles: { assocAdmin = [], admin = [] },
    } = apiConfig
    if (
      !isUndefined(numSelected) &&
      numSelected !== 0 &&
      (auth.isAuthorized(assocAdmin) || auth.isAuthorized(admin))
    ) {
      return true
    } else {
      return false
    }
  }
  refreshAutoOrderGrid = () => {
    const {
      fetchAutoOrderGridSample = () => {},
      fetchAutoOrderGridSampleSubClass = () => {},
    } = this.props
    const {
      currentTabValue = '',
      aogSubclassFilters = {},
      aogFilters = {},
    } = this.state
    const curFilters =
      currentTabValue === 'aog' ? aogFilters : aogSubclassFilters

    let updatedFilters = {}
    const filterTypeKeys = {
      Department: 'departmentId',
      Brands: 'brandId',
      Class: 'classId',
    }
    Object.keys(curFilters).map((filterType = '') => {
      const currentFilter = curFilters[filterType] || []
      const curFilterSelValues = currentFilter.map((obj) =>
        filterType === 'Class' ? Number(obj.id.split('-')[1]) : obj.id
      )
      updatedFilters[filterTypeKeys[filterType] || filterType] = {}
      updatedFilters[filterTypeKeys[filterType] || filterType][
        'requestParamValue'
      ] = curFilterSelValues
      return filterType
    })
    currentTabValue === 'aogsubclass'
      ? fetchAutoOrderGridSampleSubClass(updatedFilters)
      : fetchAutoOrderGridSample(updatedFilters)
  }
  renderAutoComplete = (
    filterOptions = [],
    label = '',
    onChange = () => {},
    selectedValue = []
  ) => {
    return (
      <CheckBoxAutoComplete
        options={filterOptions}
        label={label}
        styles={{ alignSelf: 'center' }}
        onChange={onChange}
        selectedValue={selectedValue}
        limitTags={2}
      />
    )
  }
  onAutoCompleChange =
    (label) =>
    (event, value = [], reason) => {
      const {
        aogSubclassFilters = {},
        aogFilters = {},
        currentTabValue = '',
      } = this.state
      const finalAogSubclassFilters = Object.assign({}, aogSubclassFilters, {
        [label]: value,
      })
      let finalAogFilters = Object.assign({}, aogFilters, {
        [label]: value,
      })
      if (
        label === 'Department' &&
        reason === 'removeOption' &&
        value.length === 0
      ) {
        finalAogFilters = Object.assign({}, finalAogFilters, {
          ['Class']: [],
        })
      }
      const filtersObj =
        currentTabValue === 'aog'
          ? { aogFilters: finalAogFilters }
          : { aogSubclassFilters: finalAogSubclassFilters }
      this.setState((state) => {
        return {
          ...state,
          ...filtersObj,
        }
      })
    }
  additionalFiltersContent = () => {
    const {
      allDepartmentsOptions = [],
      allBrandOptions = [],
      editFlyOut = () => {},
      csvCompleteAutoOrderSamples = [],
      filterOptionsByFilter = [],
      csvHeaders = [],
      classes = {},
      downloadAOGCSV = () => {},
    } = this.props
    const {
      currentTabValue = '',
      aogSubclassFilters = {},
      aogFilters = {},
    } = this.state

    const curFilters =
      currentTabValue === 'aog' ? aogFilters : aogSubclassFilters

    const csvReport = {
      data: csvCompleteAutoOrderSamples,
      headers: csvHeaders,
      filename: 'Auto_ordering_Settings.csv',
    }
    const {
      roles: { autoOrderEdit = [] },
    } = apiConfig
    const {
      auth: { isAuthorized = () => {} },
    } = this.props
    const classOptions = !isEmpty(curFilters['Department'])
      ? filterOptionsByFilter['Class']
      : []
    return (
      <Grid container data-testid="additional-filters-content">
        <Grid
          container
          spacing={2}
          style={{
            margin: '14px 0px',
          }}
        >
          <Grid item style={{ width: '300px' }}>
            {this.renderAutoComplete(
              allDepartmentsOptions,
              'Department',
              this.onAutoCompleChange,
              curFilters['Department']
            )}
          </Grid>
          <Grid item style={{ width: '300px' }}>
            {this.renderAutoComplete(
              classOptions,
              'Class',
              this.onAutoCompleChange,
              curFilters['Class']
            )}
          </Grid>
          <Grid item style={{ width: '300px' }}>
            {this.renderAutoComplete(
              allBrandOptions,
              'Brands',
              this.onAutoCompleChange,
              curFilters['Brands']
            )}
          </Grid>
        </Grid>
        {isAuthorized(autoOrderEdit) ? (
          <Grid item className={classes.autoOrderEdit}>
            <Box display="flex" justifyContent="flex-end">
              <Button
                id="autoOrderEditBtn"
                variant="outlined"
                color="primary"
                to="/"
                startIcon={<Create />}
                onClick={() => editFlyOut(true)}
              >
                {'Create'}
              </Button>
            </Box>
          </Grid>
        ) : (
          <div></div>
        )}
        {currentTabValue === 'aog' && (
          <Grid item xs={12} className={classes.downloadButton}>
            <Button
              id="rsf_downloadshiptoloc"
              color="primary"
              variant="outlined"
              onClick={() => {}}
              // className={classes.}
              startIcon={<DownloadIcon />}
              href="/pegasusdocs/TCIN Assets_Approved Exceptions List.xlsx"
            >
              Exception List
            </Button>
          </Grid>
        )}
        <Grid
          item
          className={
            isAuthorized(autoOrderEdit)
              ? classes.autoOrderDownload
              : classes.autoOrderNotAuthorizedEdit
          }
        >
          <Button
            variant="outlined"
            color="primary"
            startIcon={<GetApp />}
            onClick={() => downloadAOGCSV()}
          >
            As CSV
          </Button>
        </Grid>
      </Grid>
    )
  }
  editSubmitData = (requestBody) => {
    const { editSubmit = () => {} } = this.props
    editSubmit(requestBody)
  }

  renderEditFlyout = () => {
    const {
      editFlyOut = () => {},
      selectedData = [],
      allDepartmentsOptions = [],
      editSubmit = () => {},
      autoOrderSamples = [],
      filteredSamples = [],
    } = this.props
    const { currentTabValue = '' } = this.state
    const selectedFields =
      currentTabValue === 'aog'
        ? RenderSelectionFields?.filter((obj) => obj?.id !== 'SubClass')
        : RenderSelectionFields
    return (
      <Box sx={{ width: 'auto', minWidth: 400 }} role="presentation">
        <EditAutoOrderSamplesFlyout
          closePopup={editFlyOut}
          selectedOptions={selectedData}
          handleSubmit={editSubmit}
          allDepartmentsOptions={allDepartmentsOptions}
          refreshAutoOrderGrid={this.refreshAutoOrderGrid}
          data={autoOrderSamples}
          renderSelectionFields={selectedFields || []}
          currentTabValue={currentTabValue}
        />
      </Box>
    )
  }
  onSelected = (selectedData, selected) => {
    const { id = '' } = selected
    return (
      findIndex(selectedData, function (obj) {
        return obj.id === id
      }) !== -1
    )
  }
  renderTabsContent = () => {
    const {
      autoOrderGridColumn = [],
      autoOrderSamples = [],
      filteredSamples = [],
      fetchAutoORderGridLoading = false,
      showPopup,
      closePopup,
      popupIsVisible,
      popupHistory,
      aogHistoryLoading = false,
      aogItem,
      classes,
      onCheckBoxChange = () => {},
      onCheckBoxHeaderChange = () => {},
      selectedData = [],
      numSelected = 0,
      auth = {},
    } = this.props
    const { currentTabValue = '' } = this.state
    const {
      roles: { assocAdmin = [], admin = [] },
    } = apiConfig
    const aogColumnData =
      autoOrderGridColumn?.filter((obj) => obj.id !== 'subClassId') || []
    const aogSubclassColumnData =
      autoOrderGridColumn?.filter((obj) => obj.id !== 'weeksFromLaunch') || []

    return (
      <>
        {(() => {
          switch (currentTabValue) {
            case 'aog': {
              return (
                <FlexibleTable
                  cascadeFieldKeys={[]}
                  checkBoxEnabled={
                    auth.isAuthorized(assocAdmin) || auth.isAuthorized(admin)
                  }
                  columnData={aogColumnData}
                  data={filteredSamples}
                  uniqueIdentifierInData={'brandId'}
                  dataFieldKeys={[]}
                  editEnabled={false}
                  enableSearch
                  isLoading={fetchAutoORderGridLoading}
                  paginationAtApiLevel={false}
                  showPopup={showPopup}
                  additionalActions={true}
                  additionalFiltersContent={this.additionalFiltersContent}
                  onCheckBoxChange={onCheckBoxChange}
                  onCheckBoxHeaderChange={onCheckBoxHeaderChange}
                  selected={selectedData}
                  numSelected={numSelected}
                  onSelected={this.onSelected}
                />
              )
            }
            case 'aogsubclass':
              return (
                <FlexibleTable
                  cascadeFieldKeys={[]}
                  checkBoxEnabled={false}
                  columnData={aogSubclassColumnData}
                  data={filteredSamples}
                  uniqueIdentifierInData={'brandId'}
                  dataFieldKeys={[]}
                  editEnabled={false}
                  enableSearch
                  isLoading={fetchAutoORderGridLoading}
                  paginationAtApiLevel={false}
                  showPopup={() => {}}
                  additionalActions={true}
                  additionalFiltersContent={this.additionalFiltersContent}
                />
              )
            default:
              break
          }
        })()}
        <TabbedPopUp
          dataTabLabels={['AOG HISTORY']}
          isVisible={popupIsVisible}
          data={makeTabTables(
            popupHistory,
            classes,
            ['AOG HISTORY'],
            '',
            '',
            'aogpage'
          )}
          onClose={closePopup}
          title={
            'Department: ' +
            (aogItem?.departmentId || '') +
            ' & Class: ' +
            (aogItem?.classId || '')
          }
        />
      </>
    )
  }
  handleClose = () => {
    const { editItemsFlyoutToggle = () => {}, unsetSelectedData = () => {} } =
      this.props
    unsetSelectedData()
    editItemsFlyoutToggle()
  }
  handleSaveClick = (editInformation) => {
    const { editSubmit = () => {} } = this.props
    const requestBody = editInformation.map((obj) => {
      let requesObj = {
        department_id: obj.departmentId,
        class_id: obj.classId,
        brands: Array.isArray(obj.brands)
          ? obj.brands.map((b) => ({
              id: b?.value ?? b?.id,
              name: b?.label || b.name,
            }))
          : [],
        id: obj.id,
        weeks_from_launch: obj.weeksFromLaunch,
        ship_to_location: obj.shipToLocation,
        quantity: obj.quantity,
        size: normalizeSizeValues(obj.size),
      }
      return requesObj
    })
    editSubmit(requestBody, this.refreshAutoOrderGrid)
    this.handleClose()
  }
  renderEditItemsFlyout = () => {
    const {
      numSelected = Number(0),
      classes = {},
      autoOrderGridColumn = [],
      selectedData = [],
    } = this.props
    const dataFieldKeys = autoOrderGridColumn.map((obj) => obj.id) || []
    return (
      <ItemEditCard
        dataKeyLabels={[]}
        handleSaveClick={this.handleSaveClick}
        isVisible={true}
        items={selectedData}
        onClose={this.handleClose}
        title="Edit Samples"
        editColumnData={autoOrderGridColumn}
        dataFieldKeys={dataFieldKeys}
        onChangeRowsPerPage={() => {}}
        onPopupChange={() => {}}
        cascadeFieldKeys={[
          'shipToLocation',
          'weeksFromLaunch',
          'quantity',
          'size',
          'brandName',
        ]}
        sourcePage={'autoOrderSamples'}
      />
    )
  }

  setCurrentTabValue = (currentTab = '') => {
    this.setState(() => {
      return {
        currentTabValue: currentTab,
      }
    })
  }

  render() {
    const {
      classes = {},
      editFlyoutOpen = false,
      renderBackButton = true,
      isEditItemsFlyoutOpen,
      auth = {},
    } = this.props
    const { currentTabValue = 'aog' } = this.state

    return (
      <div className={classes.root}>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
          <Grid item>
            <h1>Auto Ordering Grid</h1>{' '}
          </Grid>
          {renderBackButton && (
            <Grid item>
              <Button
                variant="text"
                color="primary"
                component={Link}
                to="/"
                startIcon={<ArrowBackIcon />}
                className={classes.filtersContentCls}
              >
                {'Back To Auto Order'}
              </Button>
            </Grid>
          )}
        </Grid>
        <Grid container>
          <SwipeableDrawer anchor="right" open={editFlyoutOpen}>
            <Box
              sx={{
                width: 500,
              }}
              role="presentation"
            >
              {this.renderEditFlyout()}
            </Box>
          </SwipeableDrawer>
          <Grid item xs={12}>
            <CustomTabs
              tabLabels={aogTabLabels}
              renderTabsContent={this.renderTabsContent}
              setCurrentTabValue={this.setCurrentTabValue}
              defaultTab={currentTabValue}
              showTabsPanel={false}
            />
          </Grid>
          <ShowIf condition={this.toggleOpen()}>
            {this.renderBottomBar()}
          </ShowIf>
          {!!isEditItemsFlyoutOpen && this.renderEditItemsFlyout()}
        </Grid>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    tabValue: state.order.tabValue,
    autoOrderSamples: getAutoOrderSamples()(state),
    autoOrderGridColumn: getAutoOrderGridColumn()(state),
    csvHeaders: getCsvHeaders()(state),
    allBrandOptions: getAllBrandOptions()(state),
    allDepartmentsOptions: getAllDepartmentsOptions()(state),
    csvCompleteAutoOrderSamples: getCsvCompleteAutoOrderSamples()(state),
    filterOptionsByFilter: getFilterOptionsByFilter()(state),
    editFlyoutOpen: state.autoOrderFilters.editFlyoutOpen,
    fetchAutoORderGridLoading: state.autoOrderSamples.fetchAutoORderGridLoading,
    showPopup: state.autoOrderSamples.showPopup,
    popupIsVisible: state.autoOrderSamples.popupIsVisible,
    popupHistory: state.autoOrderSamples.aogHistory,
    aogHistoryLoading: state.autoOrderSamples.aogHistoryLoading,
    aogItem: state.autoOrderSamples.aogItem,
    numSelected: state.autoOrderSamples.numSelected,
    selectedData: state.autoOrderSamples.selectedData,
    isEditItemsFlyoutOpen: state.autoOrderSamples.isEditItemsFlyoutOpen,
    editColumnData: state.autoOrderSamples.editColumnData,
    filteredSamples: state.autoOrderSamples.filteredSamples,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAutoOrderGridSample: (params = {}) =>
      dispatch(fetchAutoOrderGridSample(params)),
    fetchAutoOrderGridSampleSubClass: (params = {}) =>
      dispatch(fetchAutoOrderGridSampleSubClass(params)),
    getAllBrands: () => dispatch(getAllBrands()),
    getAllDepartments: () => dispatch(getAllDepartments('')),
    editFlyOut: (data) => dispatch(editFlyOut(data)),
    editSubmit: (requestBody = [], refreshAutoOrderGrid) =>
      dispatch(editSubmit(requestBody, refreshAutoOrderGrid)),
    setHeaderTitleArray: (headerTitleArray = []) =>
      dispatch(setHeaderTitleArray(headerTitleArray)),
    openAutoOrder: (data) => dispatch(openAutoOrder(data)),
    showPopup: (item) => dispatch(showPopup(item)),
    closePopup: () => dispatch(closePopup()),
    getClassByMultiDepartment: (deptIds = []) =>
      dispatch(getClassByMultiDepartment(deptIds)),
    onCheckBoxChange: (selected) => dispatch(setCheckBox(selected)),
    onCheckBoxHeaderChange: (selectedList = []) =>
      dispatch(setCheckBoxHeaderChange(selectedList)),
    editItemsFlyoutToggle: () => dispatch(editItemsFlyoutToggle()),
    getSizes: () => dispatch(getSizes()),
    downloadAOGCSV: () => dispatch(downloadAOGCSV()),
    unsetSelectedData: () => dispatch(unsetSelectedData()),
    setAutoOrderSamplesSuccess: (filteredSamples, params) =>
      dispatch(setAutoOrderSamplesSuccess(filteredSamples, params)),
  }
}
export default withHOCs({
  auth: true,
  nav: true,
  styles,
  connectParams: {
    mapStateToProps,
    mapDispatchToProps,
  },
})(AutoOrderingGrid)
